export * from './bundle-contract-details-template';
